import { IntegrationOne } from '@/components/integrations/integration-one';
import { Layout, PageContent, PageHeader, PageLayout } from '@/components/ui/design-system';
import { useTranslation } from '@/hooks/use-translation';
import { formatIntegrationName } from '@/lib/utils';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/integrations/$integrationName')({
  component: RouteComponent,
});

function RouteComponent() {
  const { integrationName } = Route.useParams();
  const { t } = useTranslation('desktop_ui');
  const navigate = useNavigate();

  return (
    <PageLayout>
      <PageHeader
        parent={{
          label: t('settings.sidebar.integrations'),
          onClick: () => navigate({ to: '/settings/integrations' }),
        }}
        title={t(`integration.${integrationName}.title`, formatIntegrationName(integrationName))}
      />
      <PageContent>
        <Layout>
          <IntegrationOne integrationName={integrationName} />
        </Layout>
      </PageContent>
    </PageLayout>
  );
}
